import {observable, action, computed} from 'mobx';
import {deserialize} from 'spa/store';

const isServer = typeof window === 'undefined';

class NotificationsState {
  @observable list = [];
  @computed get keys() {
    return this.list.map(({id}) => id);
  }

  @action add(_notification) {
    if (!_notification.id) throw new Error('Missing notification id');

    const notification = {
      delay: 15000,
      ..._notification,
    };

    notification.dismiss = action(`dismiss notification ${notification.id}`, () => {
      clearTimeout(notification.timeout);
      this.list.splice(this.keys.indexOf(notification.id), 1);
    });

    if (!isServer) {
      notification.timeout = setTimeout(
        notification.dismiss,
        notification.delay,
      );
    }

    const index = this.keys.indexOf(notification.id);
    if (index > -1) {
      // replace item
      clearTimeout(this.list[index].timeout);
      this.list.splice(index, 1, notification);
    } else {
      // add new item
      this.list.push(notification);
    }
  }

  @action dismiss(id) {
    const index = this.keys.indexOf(id);
    if (index > -1) {
      this.list[index].dismiss();
    }
  }

  @action deserialize(value) {
    deserialize(this, value);

    if (!isServer && value.list) {
      value.list.forEach((notification) => {
        if (notification.timeout) return;

        /* eslint-disable no-param-reassign */
        notification.dismiss = action(`dismiss notification ${notification.id}`, () => {
          clearTimeout(notification.timeout);
          this.list.splice(this.keys.indexOf(notification.id), 1);
        });

        notification.timeout = setTimeout(
          notification.dismiss,
          notification.delay,
        );
        /* eslint-enable no-param-reassign */
      });
    }
  }

  dispose() {
    this.list.forEach(item => item.dismiss());
  }
}

export default NotificationsState;



// WEBPACK FOOTER //
// ./spa/state/notifications.jsx